import script from "./PlacementSizeApprovalDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./PlacementSizeApprovalDialog.vue?vue&type=script&setup=true&lang=js"

import "./PlacementSizeApprovalDialog.vue?vue&type=style&index=0&id=701e639f&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-701e639f"]])

export default __exports__